var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "complaint-work-order" }, [
        _c("div", { staticStyle: { color: "#409eff" } }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("driver.platform01")))]),
          _c("span", { staticStyle: { margin: "0 10px" } }, [
            _vm._v(_vm._s(_vm.replyMessageData.platform)),
          ]),
          _c("span", [_vm._v(_vm._s(_vm.$t("GlobalSetObj.ScanNumber")) + ":")]),
          _c("span", { staticStyle: { margin: "0 10px" } }, [
            _vm._v(_vm._s(_vm.replyMessageData.scanNumber)),
          ]),
          _c("span", [_vm._v(_vm._s(_vm.$t("driver.recipientCPF")) + ":")]),
          _c("span", { staticStyle: { margin: "0 10px" } }, [
            _vm._v(_vm._s(_vm.replyMessageData.receiveTax)),
          ]),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("orderCenterCont.telephoneNumber")) + ":"),
          ]),
          _c("span", { staticStyle: { margin: "0 10px" } }, [
            _vm._v(_vm._s(_vm.replyMessageData.receiveMobile)),
          ]),
        ]),
        _c(
          "div",
          { ref: "messageListRef", staticClass: "message-content-bg" },
          _vm._l(_vm.messageDetail, function (item, index) {
            return _c("div", { key: index }, [
              item.createUser !== _vm.currentId
                ? _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
                    _c("div", { staticStyle: { "text-align": "left" } }, [
                      _c("div", [
                        item.type === 1
                          ? _c("img", {
                              staticClass: "img",
                              staticStyle: { width: "50px !important" },
                              attrs: { src: _vm.cs, alt: "cs" },
                            })
                          : item.type === 3
                          ? _c("img", {
                              staticClass: "img",
                              staticStyle: { width: "50px !important" },
                              attrs: { src: _vm.dc, alt: "dc" },
                            })
                          : _c("img", {
                              staticClass: "img",
                              staticStyle: { width: "50px !important" },
                              attrs: { src: _vm.aj, alt: "aj" },
                            }),
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "-60px",
                            "margin-left": "60px",
                          },
                        },
                        [
                          _c("div", [
                            _c(
                              "span",
                              {
                                style: {
                                  color:
                                    item.type === 2 ? "#ffb907" : "#409eff",
                                },
                              },
                              [_vm._v(_vm._s(item.createUserName))]
                            ),
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "10px" } },
                              [_vm._v(_vm._s(item.createTime))]
                            ),
                          ]),
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "complaint-work-order-message-content",
                                style: {
                                  float: "left",
                                  backgroundColor:
                                    item.type === 2 ? "#f6f0df" : "#ffffff",
                                },
                              },
                              [
                                _c("div", {
                                  staticClass: "wrap-text",
                                  staticStyle: {
                                    "text-align": "left",
                                    "max-width": "720px",
                                  },
                                  domProps: { innerHTML: _vm._s(item.message) },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.getImgSrc($event)
                                    },
                                  },
                                }),
                                item.mediaUrl
                                  ? _c(
                                      "div",
                                      { staticStyle: { "margin-top": "10px" } },
                                      _vm._l(
                                        item.mediaUrlList,
                                        function (url, ind) {
                                          return _c("el-image", {
                                            key: ind,
                                            staticStyle: {
                                              width: "100px",
                                              height: "100px",
                                            },
                                            attrs: {
                                              "preview-src-list":
                                                item.mediaUrlList,
                                              src: url,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c("div", { staticStyle: { clear: "both" } }),
                          ]),
                        ]
                      ),
                    ]),
                  ])
                : _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
                    _c("div", { staticStyle: { "text-align": "right" } }, [
                      _c("div", [
                        item.type === 1
                          ? _c("img", {
                              staticClass: "img",
                              staticStyle: { width: "50px !important" },
                              attrs: { src: _vm.cs, alt: "cs" },
                            })
                          : item.type === 3
                          ? _c("img", {
                              staticClass: "img",
                              staticStyle: { width: "50px !important" },
                              attrs: { src: _vm.dc, alt: "dc" },
                            })
                          : _c("img", {
                              staticClass: "img",
                              staticStyle: { width: "50px !important" },
                              attrs: { src: _vm.aj, alt: "aj" },
                            }),
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "-60px",
                            "margin-right": "60px",
                            "text-align": "right",
                          },
                        },
                        [
                          _c("div", [
                            _c(
                              "span",
                              { staticStyle: { "margin-right": "10px" } },
                              [_vm._v(_vm._s(item.createTime))]
                            ),
                            _c(
                              "span",
                              {
                                style: {
                                  color:
                                    item.type === 2 ? "#ffb907" : "#409eff",
                                },
                              },
                              [_vm._v(_vm._s(item.createUserName))]
                            ),
                          ]),
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "complaint-work-order-message-content",
                                staticStyle: {
                                  float: "right",
                                  "background-color": "#c6e6f4",
                                },
                              },
                              [
                                _c("div", {
                                  staticClass: "wrap-text",
                                  staticStyle: {
                                    "text-align": "left",
                                    "max-width": "720px",
                                  },
                                  domProps: { innerHTML: _vm._s(item.message) },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.getImgSrc($event)
                                    },
                                  },
                                }),
                                item.mediaUrl
                                  ? _c(
                                      "div",
                                      { staticStyle: { "margin-top": "10px" } },
                                      _vm._l(
                                        item.mediaUrlList,
                                        function (url, ind) {
                                          return _c("el-image", {
                                            key: ind,
                                            staticStyle: {
                                              width: "100px",
                                              height: "100px",
                                            },
                                            attrs: {
                                              "preview-src-list":
                                                item.mediaUrlList,
                                              src: url,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c("div", { staticStyle: { clear: "both" } }),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
            ])
          }),
          0
        ),
      ]),
      _c(
        "div",
        { staticStyle: { padding: "10px", "margin-top": "20px" } },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "contentValue" } },
                        [
                          _c("el-input", {
                            ref: "inputRef",
                            staticClass: "red-text-input",
                            attrs: {
                              maxlength: 3000,
                              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                              rows: 5,
                              "show-word-limit": "",
                              type: "textarea",
                            },
                            model: {
                              value: _vm.ruleForm.contentValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "contentValue", $$v)
                              },
                              expression: "ruleForm.contentValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flx-between" },
            [
              _c(
                "div",
                [
                  _c(
                    "el-upload",
                    {
                      ref: "uploadRef",
                      attrs: {
                        "before-upload": _vm.beforeAvatarUpload,
                        "file-list": _vm.imageList,
                        "http-request": _vm.upLoad,
                        limit: 3,
                        "on-exceed": _vm.handleExceed,
                        "on-remove": _vm.handleDeleteImgRemove,
                        action: "#",
                        "list-type": "picture-card",
                        multiple: "",
                      },
                      model: {
                        value: _vm.ruleForm.photograph,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "photograph", $$v)
                        },
                        expression: "ruleForm.photograph",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "iconfont icon-tupiantianjia",
                        staticStyle: { "font-size": "20px" },
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    { staticStyle: { color: "#606266", "font-size": "14px" } },
                    [_vm._v(_vm._s(_vm.$t("fixDutyFine.addPhotos")))]
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.loadingBtn, type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitMsg("ruleForm")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Reply")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showViewer
        ? _c("el-image-viewer", {
            attrs: { "on-close": _vm.closeViewer, "url-list": _vm.imgArr },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }